import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function initPushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.log('Push notifications not supported');
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw-push.js');
    await navigator.serviceWorker.ready;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Push permission denied');
      return false;
    }

    const { data } = await axios.get(`${API_URL}/api/push/vapid-key`);
    const vapidKey = urlBase64ToUint8Array(data.public_key);

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: vapidKey,
    });

    const subJson = subscription.toJSON();
    await axios.post(`${API_URL}/api/push/subscribe`, {
      endpoint: subJson.endpoint,
      keys: subJson.keys,
    }, { withCredentials: true });

    console.log('Push notifications enabled');
    return true;
  } catch (err) {
    console.error('Push init error:', err);
    return false;
  }
}

export async function isPushEnabled() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}

export async function disablePushNotifications() {
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      const subJson = sub.toJSON();
      await axios.post(`${API_URL}/api/push/unsubscribe`, {
        endpoint: subJson.endpoint,
        keys: subJson.keys,
      }, { withCredentials: true });
      await sub.unsubscribe();
    }
  } catch (err) {
    console.error('Push disable error:', err);
  }
}
